/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const SunSolidV6 = (props) => (
  <Icon {...props} name="Sun Solid V6">
    <path d="M8 4.972c-1.657 0-2.972 1.343-2.972 2.972S6.316 10.972 8 10.972 10.972 9.629 10.972 8 9.656 4.972 8 4.972zm7.916 5.872-1.975-2.872 1.973-2.844a.477.477 0 0 0-.307-.741l-3.406-.616-.616-3.406a.477.477 0 0 0-.741-.307L8 2.059 5.128.085a.477.477 0 0 0-.741.307L3.8 3.8l-3.408.616c-.341.059-.505.456-.307.713l1.974 2.872-1.973 2.844a.477.477 0 0 0 .307.741l3.406.616.616 3.406a.477.477 0 0 0 .741.307L8 13.941l2.844 1.973c.285.198.68.035.741-.307l.616-3.406 3.406-.616a.477.477 0 0 0 .308-.742zM8 11.972A3.97 3.97 0 0 1 4.028 8c0-2.209 1.791-3.972 3.972-3.972S11.972 5.819 11.972 8A3.952 3.952 0 0 1 8 11.972z" />
  </Icon>
);

export default SunSolidV6;
